import { HeartFilled, LeftOutlined, PlusOutlined, RightOutlined, HeartOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import product from "../../assets/product.png";
import heart from "../../assets/heart.png";
import { Rate, message } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { fetchProducts } from "../../redux/ecommerce/productsSlice";
import { toggleFavorite } from "../../redux/ecommerce/favoriteSlice";
import OrderEmpty from "../../assets/myOrders/OrderEmpty.png";

const LatestOffers = () => {

  const { t, i18n } = useTranslation();
  const { language } = i18n;

  const dispatch = useDispatch();

  const [localFavorites, setLocalFavorites] = useState({});

  const handleToggleFavorite = async (e, item) => {
    e.preventDefault();
    e.stopPropagation();

    const isFav = localFavorites[item.id] || false;
    const newStatus = isFav ? "no" : "yes";

    try {
      await dispatch(
        toggleFavorite({
          eco_products_id: item.id,
          status: newStatus,
        })
      ).unwrap();

      setLocalFavorites((prev) => ({ ...prev, [item.id]: !isFav }));
      message.success(isFav ? "تمت الإزالة من المفضلة" : "تمت الإضافة للمفضلة");
    } catch (error) {
      console.error("Error toggle favorite:", error);
      message.error("حدث خطأ أثناء تعديل المفضلة.");
    }
  };

  const { products, statusPro, errorPro } = useSelector(
    (state) => state.products
  );

  useEffect(() => {
    if (statusPro === "succeeded") {
      dispatch(fetchProducts({ status: "on_seal", category_id: "" }));
    }
  }, [statusPro, dispatch]);

  const onChange = (key) => {
    console.log(key);
  };

  if (statusPro === "loading") {
    return (
      <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
        Loading products...
      </p>
    );
  }

  // const categoryProducts = products.filter(
  //   (product) => product.eco_category_id === ""
  // );

  // if (categoryProducts.length === 0) {
  //   return (
  //     <p className="text-center text-xl text-[#FE9B71] col-span-2 mt-7 pt-7">
  //       لا توجد منتجات متوفرة في هذه الفئة
  //     </p>
  //   );
  // }

  // const chunkProducts = (products, chunkSize) => {
  //   const result = [];
  //   for (let i = 0; i < products.length; i += chunkSize) {
  //     result.push(products.slice(i, i + chunkSize));
  //   }
  //   return result;
  // };

  // const productChunks = chunkProducts(categoryProducts, 3);

  const ProductImage = ({ item }) => {
    const isFav = localFavorites[item.id] || false;

    return (
      <div className="relative">
        <img
          src={item.image}
          alt={item.name_en}
          className="rounded-3xl w-[350px] h-[300px] mx-auto"
          onError={(e) => {
            e.target.src = OrderEmpty;
          }}
        />

        <div
          onClick={(e) => handleToggleFavorite(e, item)}
          className="bg-[#FCFBFA] w-[50px] h-[50px] flex items-center justify-center rounded-full absolute top-5 right-5 cursor-pointer hover:bg-gray-100 transition text-[#fe6625]"
        >
          {item.favorite === "no" ? (
            <HeartOutlined className="text-2xl" />
          ) : (
            <img src={heart} className="mx-auto w-[22px]" alt="favorite" />
          )}
        </div>

        {item.discount > 0 && (
          <div className="bg-[#fb7c3eb3] text-white border border-white rounded-lg py-2 px-3 absolute -top-4 -left-10">
            {item.discount}% {t("OFF")}
          </div>
        )}
      </div>
    )
  };

  const ProductInfo = ({ item }) => (
    <div>
      <h3 className="text-[#283D63] text-2xl font-semibold">
        {item.name_en}
      </h3>

      <Rate
        disabled
        defaultValue={item.average_rating}
        className="mt-3 custom-rate"
      />

      <p className="text-[#737E91] text-lg mt-3">
        {item.text_en}
      </p>

      <div className="mt-4 flex items-center flex-wrap gap-2">
        {item.colors?.map((color) => (
          <button
            key={color.id}
            style={{ backgroundColor: color.eco_color_id }}
            className="w-[45px] h-[35px] rounded-lg"
          />
        ))}
      </div>

      <div className="lg:flex items-center justify-between max-lg:px-3 mt-4">
        <p className="text-[#606D84] font-semibold text-lg">
          {(item.discount > 0
            ? item.price - (item.price * item.discount) / 100
            : item.price).toFixed(2)} {t("SR")}
        </p>

        {item.discount > 0 && (
          <p className="text-gray-400 line-through text-base">
            {item.price} {t("SR")}
          </p>
        )}

        <button className="bg-[#FE9B71] text-white flex items-center px-4 py-2 text-lg rounded-full font-semibold max-lg:mt-4">
          {t("Add")} <PlusOutlined className={language === "en" ? "ml-4" : "mr-4"} />
        </button>

        <Link
          to={`/product/${item.id}`}
          className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] px-4 py-2 text-lg flex items-center justify-center font-semibold max-lg:mt-4"
        >
          {t("View details")}
          {language == "en" ? (
            <>
              <RightOutlined className="ml-2 font-bold" />
            </>
          ) : (
            <>
              <LeftOutlined className="mr-2 font-bold" />
            </>
          )}
        </Link>
      </div>
    </div>
  );

  return (
    <div className="py-14">
      <div>
        <h3 className="text-[#14294F] text-2xl font-semibold text-center">
          {t("Our Latest Offers")}
        </h3>
        <p className="text-[#737E91] text-lg mt-4 w-5/6 text-center mx-auto">
          {t("Discover the offers on products at Samoula store.")}
        </p>
      </div>

      {/* one  */}
      {/* <div className="mt-14">
          <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-4 lg:items-center w-2/3 mx-auto">
            <div className="flex">
              <div className="relative">
                <img
                  src={product}
                  className="rounded-3xl w-[350px] h-[280px] mx-auto"
                />
                <div className="bg-[#FCFBFA] w-[50px] h-[50px] mx-auto flex items-center rounded-full absolute top-5 right-5">
                  <img src={heart} className="text-[#fe6625] mx-auto w-[22px]" />
                </div>
                <div className="bg-[#fb7c3eb3] text-white border border-white rounded-lg py-2 px-3 absolute -top-4 -left-10">
                  10% OFF
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-[#283D63] text-2xl font-semibold">Cage Lamp</h3>
              <Rate disabled defaultValue={5} className="mt-3 custom-rate" />
              <p className="text-[#737E91] text-lg mt-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit.
              </p>
              <div className="mt-4 flex items-center">
                <button className="bg-[#19161B] border-2 border-[#FE6625] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#ECEBEC] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#94BEEF] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#153C6A] w-[45px] h-[35px] rounded-lg mr-3"></button>
              </div>
              <div className="lg:flex items-center justify-between px-3 mt-4">
                <div>
                  <p className="text-[#606D84] font-semibold text-xl">1546 SR</p>
                </div>
                <button className="bg-[#FE9B71] text-white flex items-center px-5 py-2 text-xl rounded-full font-semibold max-lg:mt-4">
                  Add <PlusOutlined className="ml-4" />
                </button>
                <div>
                  <Link
                    to="/"
                    className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] px-5 py-2 text-xl flex items-center justify-center font-semibold max-lg:mt-4"
                  >
                    View details
                    <RightOutlined className="ml-3 font-bold" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      {/* two  */}
      {/* <div className="mt-14">
          <div className="grid grid-cols-2 max-lg:grid-cols-1 gap-4 lg:items-center w-2/3 mx-auto max-lg:flex max-lg:flex-wrap-reverse">
            <div>
              <h3 className="text-[#283D63] text-2xl font-semibold">Cage Lamp</h3>
              <Rate disabled defaultValue={5} className="mt-3 custom-rate" />
              <p className="text-[#737E91] text-lg mt-3">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut
                enim ad minim veniam, quis nostrud. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit.
              </p>
              <div className="mt-4 flex items-center">
                <button className="bg-[#19161B] border-2 border-[#FE6625] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#ECEBEC] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#94BEEF] w-[45px] h-[35px] rounded-lg mr-3"></button>
                <button className="bg-[#153C6A] w-[45px] h-[35px] rounded-lg mr-3"></button>
              </div>
              <div className="lg:flex items-center justify-between px-3 mt-4">
                <div>
                  <p className="text-[#606D84] font-semibold text-xl">1546 SR</p>
                </div>
                <button className="bg-[#FE9B71] text-white flex items-center px-5 py-2 text-xl rounded-full font-semibold max-lg:mt-4">
                  Add <PlusOutlined className="ml-4" />
                </button>
                <div>
                  <Link
                    to="/"
                    className="text-[#FE9B71] rounded-full border-2 border-[#FE9B71] px-5 py-2 text-xl flex items-center justify-center font-semibold max-lg:mt-4"
                  >
                    View details
                    <RightOutlined className="ml-3 font-bold" />
                  </Link>
                </div>
              </div>
            </div>

            <div className="flex justify-end">
              <div className="relative">
                <img
                  src={product}
                  className="rounded-3xl w-[350px] h-[280px] mx-auto"
                />
                <div className="bg-[#FCFBFA] w-[50px] h-[50px] mx-auto flex items-center rounded-full absolute top-5 left-5">
                  <img src={heart} className="text-[#fe6625] mx-auto w-[22px]" />
                </div>
                <div className="bg-[#fb7c3eb3] text-white border border-white rounded-lg py-2 px-3 absolute -top-4 -right-10">
                  30% OFF
                </div>
              </div>
            </div>
          </div>
        </div> */}

      {products?.map((item, index) => {
        const isOdd = index % 2 !== 0;

        return (
          <div key={item.id} className="mt-14">
            <div
              className={`grid grid-cols-2 max-lg:grid-cols-1 gap-4 lg:items-center w-2/3 mx-auto ${isOdd ? "max-lg:flex max-lg:flex-wrap-reverse" : ""
                }`}
            >
              {/* التفاصيل */}
              {!isOdd && (
                <>
                  <div className="flex">
                    <ProductImage item={item} />
                  </div>

                  <ProductInfo item={item} />
                </>
              )}

              {isOdd && (
                <>
                  <ProductInfo item={item} />

                  <div className="flex justify-end">
                    <ProductImage item={item} />
                  </div>
                </>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default LatestOffers;
